import React, { forwardRef, ReactNode } from 'react'

import styles from './style.module.scss'

export interface ShellLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  children: ReactNode
  testNameSpace?: string
}

export const ShellLink = forwardRef<HTMLAnchorElement, ShellLinkProps>(({ children, testNameSpace = '', tabIndex = 0, ...otherProps }, ref) => {
  return (
    <a
      className={styles.shellLink}
      tabIndex={tabIndex}
      {...otherProps}
      ref={ref}
      {...(testNameSpace.length > 0 && { 'data-testid': `${testNameSpace}-shellAnchor` })}
    >
      {children}
    </a>
  )
})

ShellLink.displayName = 'ShellLink'
